import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import UsersTab from "./UsersTab";
import SystemStatusTab from "./SystemStatusTab";
import ActivityLogsTab from "./ActivityLogsTab";
import axios from "axios";
import md5 from "md5";
import SyncConstants from "../../constants/SyncConstants";
import { add_or_update_user } from "../../actions/Team";

const Administration = () => {
    const CurrentUser = useSelector((state) => state.CurrentUser);
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("users");

    // Load/refresh team data when component mounts
    useEffect(() => {
        const authObj = {
            username: CurrentUser.data.email,
            password: CurrentUser.data.hash
        };

        axios({
            method: "get",
            auth: authObj,
            url: SyncConstants["syncBaseURL"] + "user",
            responseType: 'json'
        }).then((response) => {
            Object.values(response.data).map((value) => {
                dispatch(add_or_update_user(value.data.userName, value.data));

                let hash = md5(value.data.email);
                let string = "https://www.gravatar.com/avatar/" + hash + "?d=mp&r=g&s=50";
                let preloader = new Image();
                preloader.src = string;
            });
        }).catch(err => {
            console.error("Failed to load team data:", err);
        });
    }, []);

    // Check if user is admin
    if (!CurrentUser.data || CurrentUser.data.role !== 'administrator') {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger">
                    <h4>Zugriff verweigert</h4>
                    <p>Du benötigst Administrator-Rechte, um auf diesen Bereich zugreifen zu können.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container mt-5">
            <h1 className="mb-4">Administration</h1>

            {/* Tab Navigation */}
            <ul className="nav nav-tabs mb-4">
                <li className="nav-item">
                    <a
                        className={`nav-link cursor-pointer ${activeTab === "users" ? "active" : ""}`}
                        onClick={() => setActiveTab("users")}
                    >
                        Nutzer:innen
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={`nav-link cursor-pointer ${activeTab === "system" ? "active" : ""}`}
                        onClick={() => setActiveTab("system")}
                    >
                        System-Status
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={`nav-link cursor-pointer ${activeTab === "logs" ? "active" : ""}`}
                        onClick={() => setActiveTab("logs")}
                    >
                        Activity Logs
                    </a>
                </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content">
                {activeTab === "users" && <UsersTab />}
                {activeTab === "system" && <SystemStatusTab />}
                {activeTab === "logs" && <ActivityLogsTab />}
            </div>
        </div>
    );
};

export default Administration;
